import getConfig from 'next/config';
import { structureAddons } from '../../../../util/Format.util';
import { getCookie, setCookie } from '../../../hooks/useCookie';
import { createAcquisitionProspectPrepay } from '../../../integration/acquisition.api';
import { addPrepayAddOns, getAddOns, removeAddOns } from '../../../integration/addons.api';
import getCarts from '../../../integration/cart.api';
import { addTariffs, getTariffs } from '../../../integration/tariff.api';
import { displayCart } from '../../eir-cart/cart.util';
import { SERVICE_GROUPS, CHANNEL, OFFER_TYPE_CODE, ADDON_ITEM_GROUP } from '../../shared/Constants';

const { MOBILE } = SERVICE_GROUPS;
const { ESHOP } = CHANNEL;
const { PREPAY } = OFFER_TYPE_CODE;
const { SUBSCRIPTION, DISCOUNTS } = ADDON_ITEM_GROUP;

const { publicRuntimeConfig } = getConfig();
/**
 * @name getPrepayAddons - Function for getting prepay addons
 * @description - Function returns array of addons
 */
export const getPrepayAddons = async (
  setOnLoadError,
  setErrorModalOccurence,
  errorModal,
  errorModalOccurence,
  openAPIFailureModal,
  setOpenError
) => {
  try {
    const variables = {
      offerTypeCode: PREPAY,
      serviceGroupCode: MOBILE,
      channel: ESHOP,
      itemGroup: SUBSCRIPTION,
    };
    const addOnsData = await getAddOns({ variables });
    const result = addOnsData?.map(addon => structureAddons(addon));
    return result;
  } catch (err) {
    console.error(err);
    setOnLoadError(true);
    setOpenError(true);
    setErrorModalOccurence(errorModalOccurence + 1);
    errorModal.enable();
    openAPIFailureModal.enable();
    return err;
  }
};
/**
 * @name addAddOn - Function for adding selected addon to the cart
 */
export const addAddOn = async (
  graphql,
  catalogCode,
  rootState,
  setShowLoader,
  setOfferSelected,
  dispatch,
  prepaySIM,
  router,
  setOnLoadError,
  setErrorModalOccurence,
  errorModal,
  errorModalOccurence,
  openAPIFailureModal,
  setOpenError
) => {
  setShowLoader(catalogCode);
  try {
    let offerId;
    let result;
    let prospect;
    let variables = {};
    if (!getCookie('reference')) {
      const acq = await createAcquisitionProspectPrepay({ graphql });
      setCookie('PREPAY', 'reference', acq?.createAcquisitionProspect);
      setCookie('ION', 'cart_Type', 'NEW_ACQUISITION');
      prospect = getCookie('reference');
      variables = {
        serviceGroupCode: MOBILE,
        offerType: PREPAY,
        reference: getCookie('reference'),
      };
      const offerData = await getTariffs({ graphql, variables });
      const code = offerData?.tariffs[0]?.code;
      const offerCode = offerData?.tariffs[0].offerCode;

      variables = {
        reference: prospect,
        catalogOfferCode: offerCode,
        catalogTariffPlanCode: code,
        serviceGroup: MOBILE,
      };

      result = await addTariffs({
        graphql,
        variables,
      });
      dispatch({ type: 'SET_CART', payload: result });
      offerId = await result?.addTariff?.offers?.filter(
        offer => offer.baseOffer?.serviceGroup === MOBILE
      )[0]?.id;
    } else {
      offerId = await rootState.cart?.offers?.filter(
        offer => offer.baseOffer?.serviceGroup === MOBILE
      )[0]?.id;
    }
    variables = {
      reference: getCookie('reference'),
      catalogCode,
      offerId,
      cartType: getCookie('cart_Type'),
    };
    const data = await addPrepayAddOns({ graphql, variables });
    if (data) {
      dispatch({ type: 'SET_CART', payload: data });
      displayCart({ dispatch, nextMethod: null });
      setOfferSelected(catalogCode);
      setShowLoader('');
      if (prepaySIM === true) {
        router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/prepay/summary`);
      } else {
        router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/prepay/handsets`);
        setCookie('PREPAY', 'STANDALONE_HANDSET', false);
      }
      return data;
    }
  } catch (err) {
    console.error(err);
    setOnLoadError(true);
    setShowLoader(false);
    setOpenError(true);
    setErrorModalOccurence(errorModalOccurence + 1);
    errorModal.enable();
    openAPIFailureModal.enable();
    return err;
  }
};

export const removeAddOn = async (
  graphql,
  catalogCode,
  rootState,
  setShowLoader,
  setOfferSelected,
  dispatch,
  setOnLoadError,
  setErrorModalOccurence,
  errorModal,
  errorModalOccurence,
  openAPIFailureModal,
  setOpenError
) => {
  setShowLoader(catalogCode);
  try {
    const prospect = getCookie('reference');
    let offerId = 0;
    let addOnId = 0;
    const addOnArrays = rootState?.cart?.offers.filter(offer => offer.addOns !== undefined);
    const selectedAddOnArray = addOnArrays?.map(arr =>
      arr?.addOns?.filter(ele => {
        if (ele.catalogCode === catalogCode) {
          offerId = arr.id;
        }
        return ele.catalogCode === catalogCode;
      })
    );
    const targetArray = selectedAddOnArray?.filter(ele => ele.length > 0)[0];
    addOnId = targetArray[0].id;

    const variables = {
      reference: prospect,
      offerId,
      addOnId,
      cartType: getCookie('cart_Type'),
    };
    const data = await removeAddOns({ graphql, variables });
    setOfferSelected(null);
    setShowLoader(' ');
    dispatch({ type: 'SET_CART', payload: data });
    return data;
  } catch (err) {
    console.error(err);
    setOnLoadError(true);
    setShowLoader(false);
    setOpenError(true);
    setErrorModalOccurence(errorModalOccurence + 1);
    errorModal.enable();
    openAPIFailureModal.enable();
    return err;
  }
};

/* Adding Discount  */
export const addDiscount = async (graphql, rootState) => {
  const prospect = getCookie('reference');
  let variables = {};
  const offerId = await rootState.cart?.offers?.filter(
    offer => offer?.baseOffer?.serviceGroup === MOBILE
  )[0]?.id;
  variables = {
    offerTypeCode: PREPAY,
    serviceGroupCode: MOBILE,
    channel: ESHOP,
  };
  const addOnsData = await getAddOns({ graphql, variables });
  const addonWithSubcription = addOnsData.filter(addon => addon.itemGroup === DISCOUNTS)[0];

  const catalogCode = addonWithSubcription.code;

  variables = {
    reference: prospect,
    offerId,
    catalogCode,
    cartType: getCookie('cart_Type'),
  };
  const filterDiscountAddon = await rootState.cart?.offers[0].addOns.filter(
    a => a.catalogCode === catalogCode
  );
  if (filterDiscountAddon.length === 0) {
    const data = await addPrepayAddOns({ graphql, variables });
    if (data != null) {
      return data;
    }
  }

  console.error('error adding discount ');
};

/* Removing Discount onClick of continue */
export const removeDiscount = async ({ graphql, rootState, dispatch, openPriceChangeModal }) => {
  const prospect = getCookie('reference');
  const offerId = rootState?.cart?.offers[0].id;

  let addOnId = 0;
  let variables = {};
  addOnId = rootState?.cart?.offers[0]?.addOns.filter(item => item.itemGroup === DISCOUNTS)[0].id;

  variables = {
    reference: prospect,
    offerId,
    addOnId,
    cartType: getCookie('cart_Type'),
  };
  const data = await removeAddOns({ graphql, variables });
  if (data != null) {
    dispatch({ type: 'SET_CART', payload: data });
    openPriceChangeModal.disable();
    return data;
  }
  console.error('error removing discount ');
};

export const onLoadPrepayAddons = async (rootState, setOfferSelected, dispatch, graphql) => {
  if (getCookie('reference')) {
    if (!rootState?.cart) {
      const { getCart: cart } = await getCarts({
        graphql,
        variables: { reference: getCookie('reference') },
      });
      dispatch({ type: 'SET_CART', payload: cart });
      displayCart({ dispatch, nextMethod: null });
    }
  }
  const addOnArrays = rootState?.cart?.offers?.filter(
    offer => offer.addOns !== undefined && offer.baseOffer?.serviceGroup === MOBILE
  );
  const selectedAddOnArray = addOnArrays?.map(arr => arr?.addOns);
  const addons = selectedAddOnArray?.flat();
  const catalogCode = addons?.find(ele => ele.catalogCode)?.catalogCode;
  setOfferSelected(catalogCode);
};
